/**
 * @params: oldIds: array of ids
         newIds: array if ids

@return value:
    a delta object of ids with a value either -1,0 or 1
    Value representation:
    1: id present in newIds but not in oldIds
    -1: id not present in newIds, but present in oldIds
    0: id present both in newIds and oldIds 

Example: 
let oldsids = [1,2,3,4];
let newIds = [3,4,5,6];

delta = getDelta(oldIds, newIds);
//delta will be
    { 1: -1, 2: -1, 3: 0, 4: 0, 5: 1, 6: 1 }
 */

function getDelta(oldIds, newIds) {
  const diff = {};
  oldIds.forEach(id => {
    diff[id] = -1;
  });
  newIds.forEach(id => {
    if (diff[id] === undefined) {
      diff[id] = 0;
    }
    if (diff[id] !== 1) {
      diff[id] += 1;
    }
  });
  return diff;
}

/*
@params:
        * subscribedIds, an object with ids as key and it's value as number of subscriptions
        * delta, delta object returned from getDelta function.

@return value:
        an object with 
        {
            addedIds, //array of ids needs to be added
            removedIds, //array of ids need to be removed
            subscribedIds, //modified subscribedIds object
            didChange, // it's essentially (addedIds.length > 0 || removedIds.length > 0)
        }

Example: 
_subscribedIds = {1: 1, 2:1, 3:1, 4:1};
delta = { 1: -1, 2: -1, 3: 0, 4: 0, 5: 1, 6: 1 }

const { addedIds, removedIds, subscribedIds, didChange } = getSubscriptionupdates(_subscribedIds, delta);
Returned values:
    addedIds = [5,6];
    removedIds = [1,2];
    subscribedIds = {1: 0, 2:0, 3:1, 4:1, 5:1, 6:1};
    didChange = true
*/
/**
 *
 * @param {an object with ids as key and it's value as number of subscriptions} _subscribedIds
 * @param {delta object returned from getDelta function.} delta
 *
 * @returns
 */
function getSubscriptionUpdates(_subscribedIds, delta) {
  const diffKeys = Object.keys(delta);
  const subscribedIds = { ..._subscribedIds };
  const addedIds = [];
  const removedIds = [];
  let didChange = false;

  for (let i = 0; i < diffKeys.length; i += 1) {
    const id = diffKeys[i];
    if (!subscribedIds[id]) {
      subscribedIds[id] = 0;
    }
    subscribedIds[id] += delta[id];
    if (subscribedIds[id] > 0 && !_subscribedIds[id]) {
      addedIds.push(id);
      didChange = true;
    }
    if (subscribedIds[id] < 1) {
      removedIds.push(id);
      didChange = true;
    }
  }

  return {
    addedIds,
    removedIds,
    subscribedIds,
    didChange,
  };
}

/**
 * @returns {iterator}  Iterator to infinity
 */
function* getCounter() {
  let count = 1;
  while (true) {
    yield count;
    count += 1;
  }
}

export { getDelta, getSubscriptionUpdates, getCounter };



// WEBPACK FOOTER //
// ./src/Proxies/utilities.js